import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import { ProductModel, ProductPriceDto } from "@insite/client-framework/Types/ApiModels";

interface Parameter {
    productId: string;
    unitOfMeasure: string;
    qtyOrdered: number;
    product: ProductModel;
    productInfo: ProductInfo;
}

type HandlerType = Handler<Parameter>;

export const DispatchCompleteChangeProductByVariantQty: HandlerType = (props: any) => {
    props.dispatch({
        type: "Custom/DispatchCompleteChangeProductByVariantQty",
        productId: props.parameter.productId,
        qtyOrdered: props.parameter.qtyOrdered,
    });
};

export const chain = [DispatchCompleteChangeProductByVariantQty];

const changeProductByVariantQty = createHandlerChainRunner(chain, "changeProductByVariantQty");
export default changeProductByVariantQty;
